import { isEqual, parse } from "date-fns";
import { type DatesToExcludeType } from "../../types";
import { FieldValidationParams } from "../types";
import { validationException } from "./validator.utils";

const CONTROL_NAME = "datesToExclude";

export const validateDatesExclusion = async ({
  args,
  names,
  onValidated,
  onInvalid,
  onValidationStarted,
}: FieldValidationParams<DatesToExcludeType[]>) => {
  return new Promise((resolve, reject) => {
    const [rulesDefinition, value, _, schema] = args;
    const { instancePath = "", parentData } = schema;
    const paths = instancePath.split("/");
    const name = paths[paths.length - 1];
    const dateFormat = (parentData.date as string) || "dd/MM/yyyy";
    if (onValidationStarted) {
      onValidationStarted("datesToExclude", name);
    }
    const checkValidated = () => {
      if (onValidated) {
        onValidated(names, name, CONTROL_NAME, []);
      }
    };

    const checkInvalid = (errorCode = 0) => {
      if (onInvalid) {
        onInvalid(names, name, CONTROL_NAME, errorCode, []);
      }
    };

    const now = new Date();
    const valueToDate = parse(value, dateFormat, now);
    const hasExclusions = rulesDefinition.map(rule => {
      const { date, day, month, year } = rule;
      // if date is provided just validate it, skipping day, month and year.
      if (date) {
        const dateValue = parse(date, dateFormat, now);
        const currentItemResult = isEqual(valueToDate, dateValue);
        return currentItemResult;
      }
      const dateDay = valueToDate.getDate();
      const dateMonth = valueToDate.getMonth() + 1;
      const dateYear = valueToDate.getFullYear();

      const isDaySame = day === dateDay;
      const isMonthSame = month === dateMonth;
      const isYearSame = year === dateYear;

      if (day && month && year) {
        return isDaySame && isMonthSame && isYearSame;
      }

      if (day && month) {
        return isDaySame && isMonthSame;
      }

      if (day && year) {
        return isYearSame && isDaySame;
      }

      if (month && year) {
        return isYearSame && isMonthSame;
      }

      if (day) {
        return isDaySame;
      }

      if (month) {
        return isMonthSame;
      }

      if (year) {
        return isYearSame;
      }
      return false;
    });

    const isInvalid = hasExclusions.some(r => r);

    if (isInvalid) {
      checkInvalid();
      return reject(
        validationException(
          "datesToExclude",
          "The provided date is in the exclusion list",
        ),
      );
    }
    checkValidated();
    return resolve(true);
  });
};
